import { render, staticRenderFns } from "./StudentExtras.vue?vue&type=template&id=f0f4d6e6"
import script from "./StudentExtras.vue?vue&type=script&lang=js"
export * from "./StudentExtras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports